(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery-packery"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    if (window.innerWidth >= 768 && window.innerWidth < 1024) {
      document.querySelectorAll(".t4s-col-item.t4s-gallery-item.t4s-col-lg-4.t4s-col-md-6.t4s-col-12")[6].style.marginTop = "14.5px"
      console.log("小屏幕");
    } else {
      document.querySelectorAll(".t4s-col-item.t4s-gallery-item.t4s-col-lg-4.t4s-col-md-6.t4s-col-12")[6].style.marginTop = "3px"
      console.log("大屏幕");
    }

    if (window.innerWidth > 1200) {
      document.querySelectorAll(".t4s-col-item.t4s-gallery-item.t4s-col-lg-4.t4s-col-md-6.t4s-col-12")[6].style.marginTop = "4.5px"
    }
        
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    

  $(document).on('click', '.t4s-dropdown button:nth-child(1)', function() {
      setTimeout(function () {
        // document.querySelectorAll(".t4s-dropdown__wrapper")[0].style.top = ""
        document.querySelectorAll(".t4s-dropdown__wrapper")[0].style.overflowY = 'hidden';
        // document.querySelectorAll(".t4s-dropdown__wrapper")[0].style.transform = 'initial';
      }, 200); // Display the dropdown content after 1 second (1000 milliseconds)


      setTimeout(function () {
        document.querySelectorAll(".t4s-dropdown__wrapper")[0].style.top = '0';
      }, 200); // Display the dropdown content after 1 second (1000 milliseconds)
  });


  $(document).on('click', '.t4s-filter__values li a', function() {
    document.querySelectorAll('.t4s-filter-area')[0].style.display = "block"
  });

  // setTimeout(function () {
  //   const button = document.querySelectorAll('.t4s-dropdown button')[0];
  
  //   button.addEventListener('click', function () {
  

  //   });



  //     const elements = document.querySelectorAll('.t4s-filter__values li a');

  //     elements.forEach(element => {
  //       element.onclick = function() {
  //         setTimeout(function () {
  //           document.querySelectorAll('.t4s-filter-area')[0].style.display = "block"
  //         }, 200); // Display the dropdown content after 1 second (1000 milliseconds)
          
  //       };
  //     });
  // }, 1000); // Display the dropdown content after 1 second (1000 milliseconds)





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collection"] && !Shopify.designMode) return;
  try {
    
  // 选择所有带有类名为 "example" 的元素
  let elements = document.querySelectorAll(".t4s-image-text-content .t4s-btn");
  
  // 使用 forEach 循环遍历每个元素
  elements.forEach(function(element){
    // 在这里应用你的操作，比如移除边框样式
    element.classList.remove("t4s-btn-color-dark")
    
  });

  } catch(e) { console.error(e); }
})();
})();
